import React, { useState } from 'react';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Check } from 'lucide-react';

const QuickDemoLinkModal = ({ link, emailedTo, onClose }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Copy failed:', err);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        style={{ backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)' }}
        onClick={onClose}
      ></div>
      <div
        className="rounded-xl p-6 w-full max-w-lg mx-auto shadow-lg relative"
        style={{
          background: 'linear-gradient(to bottom right, rgba(34,52,97,0.25), rgba(11,10,31,0.05))',
          backdropFilter: 'blur(40px)',
          WebkitBackdropFilter: 'blur(50px)',
          border: '1px solid rgba(255,255,255,0.1)',
        }}
      >
        <div className="flex items-start justify-between gap-4 mb-6">
          <div className="flex items-center gap-4">
            <div className="p-2.5 bg-emerald-500/20 rounded-xl flex-shrink-0">
              <Check className="w-5 h-5 text-emerald-400" strokeWidth={3} />
            </div>
            <div>
              <h3 className="text-xl font-medium text-white">Demo Interview Ready</h3>
              <p className="text-sm text-gray-400 mt-0.5">Copy the link below or share it directly</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 rounded-full hover:bg-white/10 transition-colors flex-shrink-0"
          >
            <CloseRoundedIcon className="text-gray-400 hover:text-white" fontSize="small" />
          </button>
        </div>

        <label className="block text-sm text-[#D3B4FF] font-medium mb-2">Interview Link</label>
        <div className="flex gap-3 mb-4">
          <input
            type="text"
            readOnly
            value={link}
            className="flex-1 px-4 py-3 bg-[#0a1733] border border-[#5A4479] rounded-lg text-[#D3B4FF] text-sm focus:outline-none"
            onFocus={(e) => e.target.select()}
          />
          <button
            onClick={handleCopy}
            className="px-6 py-3 rounded-lg font-medium text-white transition-all bg-gradient-to-r from-pink-500 to-blue-500 hover:opacity-90"
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>

        {emailedTo ? (
          <p className="text-sm text-gray-400">
            A copy was also emailed to <span className="text-[#D3B4FF]">{emailedTo}</span>.
          </p>
        ) : (
          <p className="text-sm text-gray-400">Nothing was emailed. Just share the link above.</p>
        )}

        <div className="flex justify-end mt-6">
          <button
            onClick={onClose}
            className="px-8 py-2 bg-white/10 hover:bg-white/20 text-white rounded-full transition-colors text-sm"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuickDemoLinkModal;
